/**
 * Auction service for fetching auction data from backend
 */

import type { Auction, AuctionPeriod, AuctionParams } from '@/types/auctions';
import { api } from './api';
import { API_ENDPOINTS } from '@/config/endpoints';

/**
 * Fetch all active auctions
 */
export async function getAuctions(): Promise<Auction[]> {
  return await api.get<Auction[]>(API_ENDPOINTS.AUCTIONS);
}

/**
 * Fetch auction period information with timer
 */
export async function getAuctionPeriod(): Promise<AuctionPeriod> {
  return await api.get<AuctionPeriod>(API_ENDPOINTS.AUCTION_PERIOD);
}

/**
 * Fetch auction parameters (min bid fee, etc.)
 */
export async function getAuctionParams(): Promise<AuctionParams> {
  return await api.get<AuctionParams>(API_ENDPOINTS.AUCTION_PARAMS);
}

export const auctionService = {
  getAuctions,
  getAuctionPeriod,
  getAuctionParams,
};
